import { FormControl, Select } from '@mui/material'
import { Field } from 'formik'

import { NATIONALITIES } from '@/constants/nationalities'

const Nationality = ({ handleChange = () => {}, isDisabled = false }) => {
  return (
    <FormControl style={{ width: '100%' }} variant="outlined">
      <Field
        as={Select}
        data-testid="select-nationality"
        disabled={isDisabled}
        name="nationality"
        native
        onChange={handleChange}
        style={{
          boxShadow: 'inset 0 0 0 1px $medium-medium',
          height: '48px'
        }}
      >
        <option key="default-nationality" value="">
          Nacionalidade
        </option>
        {NATIONALITIES.map((nationality) => (
          <option key={nationality.nationality} value={nationality.nationality}>
            {nationality.nationality}
          </option>
        ))}
      </Field>
    </FormControl>
  )
}

export default Nationality
